module.exports = __webpack_public_path__ + "img/activity_other1.c40b2e98.jpg";